export enum PaymentGateway {
  none = 'None',
  cenpos = 'CenPOS',
  tempus = 'Tempus',
  stripe = 'Stripe',
  windcave = 'Windcave',
  xolvis = 'Xolvis'
}
